// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesOfArLanguage from './ar.json';
import messagesOfEnLanguage from './en.json';
import messagesOfEsEsLanguage from './es_ES.json';
import messagesOfFrLanguage from './fr.json';
import messagesOfHiLanguage from './hi.json';
import messagesOfKoKrLanguage from './ko_KR.json';
import messagesOfMlLanguage from './ml.json';
import messagesOfRuLanguage from './ru.json';
import messagesOfZhCnLanguage from './zh_CN.json';

export default {
  'ar': messagesOfArLanguage,
  'zh-cn': messagesOfZhCnLanguage,
  'ru': messagesOfRuLanguage,
  'ml': messagesOfMlLanguage,
  'ko-kr': messagesOfKoKrLanguage,
  'hi': messagesOfHiLanguage,
  'fr': messagesOfFrLanguage,
  'es-es': messagesOfEsEsLanguage,
  'en': messagesOfEnLanguage,
};
